import * as ko from "knockout";
import {IMessageData, IRouteDefinitionParams} from "../../index";
import {KOSubscriptionTracker} from "../../util/KOSubscriptionTracker";
import PromiseRequest from "../../req/PromiseRequest";
import {createErrorMessage} from "../../util/misc";
import {global} from '../../appContext';
import {nsRoute} from "../../util/route";
import {REQUEST_MESSAGE} from "../../constants/Language";

export let template: string = testexportp360Html;
import ParsedRouteDataDecorator = nsRoute.ParsedRouteDataDecorator;
import testexportp360Html from './testexportp360.html?raw';

export class viewModel extends ParsedRouteDataDecorator {
    isWaiting: KnockoutObservable<boolean | null> = ko.observable(null);
    isReady: KnockoutObservable<boolean | null> = ko.observable(null);
    messageData: KnockoutObservable<IMessageData | null> = ko.observable(null);
    private kosub: KOSubscriptionTracker = new KOSubscriptionTracker();
    private reqTest: PromiseRequest = global.getPromiseRequest("testexportP360");
    data!: string;

    constructor(params: IRouteDefinitionParams) {
        super(params);
        this.doRequest();
    }

    private doRequest() {
        this.isReady(false);
        this.messageData({message: REQUEST_MESSAGE});
        this.isWaiting(true);
        this.reqTest
            .request({id: global.getRouteId()}, false, {timeout: 30 * 60 * 1000})
            .then((data: any[]) => {
                this.data = data[0];
                this.messageData(null);
                this.isWaiting(false);
                this.isReady(true);
            })
            .catch((reason: string) => {
                this.isWaiting(false);
                this.messageData(createErrorMessage(String(reason)));
            });
    }

    override dispose() {
        this.kosub.unsuscribeAll();
        this.reqTest.abort();
    }

}
